module.exports = __webpack_public_path__ + "static/media/doodle_temple.fc9d4f54.png";